import Lottie from 'lottie-web';
import { useEffect, useRef } from 'react';
import GoodocSplashScreen from '@assets/animation/goodoc-logo-full-45f.json';
import * as styles from './styles';

const SplashScreen = () => {
  const splashScreenAnimationRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (splashScreenAnimationRef.current) {
      Lottie.loadAnimation({
        container: splashScreenAnimationRef.current,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: GoodocSplashScreen
      });
    }
  }, [splashScreenAnimationRef]);

  return (
    <div css={styles.container}>
      <div css={styles.loadingAnimation} ref={splashScreenAnimationRef} />
      <p css={styles.title}>의사를 만나는 가장 빠른 방법</p>
    </div>
  );
};

export default SplashScreen;
